import { useMemo } from 'react';

import { useQueryParams } from './useQueryParams';

export const useQueryState = <T extends string = string>(
  id: string,
  defaultKey = '',
) => {
  const { query, setQuery } = useQueryParams();

  const activeKey = useMemo(
    () => query.get(id) || defaultKey,
    [defaultKey, id, query],
  );

  const setActiveKey = (activeKey: T) => {
    setQuery(id, activeKey);
  };

  return { query: activeKey as T, setQuery: setActiveKey };
};
